//event-bus.vue
import Vue from 'vue';
import VueRouter, { RouterMode } from 'vue-router';
import { VueRoot } from '@env/main';
import { type } from 'os';
import { Key } from 'readline';
import { SimpleEventDispatcher } from 'strongly-typed-events';
import { isString } from 'util';
import querystring from 'query-string';
import { ControladorDeNotificaciones } from '@/components/a-interfaz/a-notificaciones/a-notificaciones';
//import { Component, Mixin, Mixins } from 'vue-mixin-decorator';

export class EventBus extends Vue
{
    public get VueRoot()
    {
        return VueRoot;
    }

    public setTitulo( titulo: string )
    {
        this.$emit( 'toolbar-mostrar' );
        this.$emit( 'toolbar-titulo', titulo );
    }

    public ocultarToolbar()
    {
        this.$emit( 'toolbar-ocultar' );
    }

    public setQuery( query: string | any )
    {
        if ( isString( query ) )
            VueRoot.$router.replace( `${VueRoot.$router.currentRoute.path}?${query}` ).catch( () => { } );
        else
            VueRoot.$router.replace( `${VueRoot.$router.currentRoute.path}?${querystring.stringify( query )}` ).catch( () => { } );

    }

    public setTitle( title: string )
    {
        if ( document.title != title )
            document.title = title;
    }

    public ControladorDeNotificaciones: ControladorDeNotificaciones = new ControladorDeNotificaciones();
    public Notificaciones: Notificacion = new Notificacion();
    public Mensajes: Mensaje = new Mensaje();

    private _onKeyDown = new SimpleEventDispatcher<KeyboardEvent>();
    public get onKeyDown() { return this._onKeyDown.asEvent(); }
    public KeyDown( e: any ) { this._onKeyDown.dispatch( e ); }

    private _onGenerandoArchivo = new SimpleEventDispatcher<boolean>();
    public get onGenerandoArchivo() { return this._onGenerandoArchivo.asEvent(); }
    public GenerandoArchivo( bo: boolean ) { this._onGenerandoArchivo.dispatch( bo ); }

    private _onNuevaVersion = new SimpleEventDispatcher<boolean>();
    public get onNuevaVersion() { return this._onNuevaVersion.asEvent(); }
    public NuevaVersion( bo: boolean ) { this._onNuevaVersion.dispatch( bo ); }

    public NovedadesUsadas: boolean = false;
    private _onNovedades = new SimpleEventDispatcher<boolean>();
    public get onNovedades() { return this._onNovedades.asEvent(); }
    public Novedades( bo: boolean ) { this._onNovedades.dispatch( bo ); }

    private _onInstalar= new SimpleEventDispatcher<boolean>();
    public get onInstalar() { return this._onInstalar.asEvent(); }
    public Instalar( bo: boolean ) { this._onInstalar.dispatch( bo ); }
    public InstalarYaVisto: boolean = false;

    private _onKeyUp = new SimpleEventDispatcher<KeyboardEvent>();
    public get onKeyUp() { return this._onKeyUp.asEvent(); }
    public KeyUp( e: any ) { this._onKeyUp.dispatch( e ); }

    public Teclas( e: any )
    {
        this.$emit( 'key', e );
    }

    public Scroll( e: any )
    {

        this.ScrollTop = e.target.documentElement.scrollTop;
        this.OffsetY = e.target.documentElement.scrollHeight - e.target.documentElement.clientHeight;
        this.PorcentajeY = ( this.OffsetY > 0 ? this.ScrollTop / this.OffsetY : 0 ) * 100;

        if ( this.ScrollTop == this.OffsetY ) this.$emit( 'scroll-end' );
        if ( this.ScrollTop == 0 ) this.$emit( 'scroll-top' );
        this.$emit( 'scroll-y', this.PorcentajeY );

    }

    public ScrollBottom( tipo: 'auto' | 'smooth' = 'auto' )
    {
        this.$nextTick( () =>
        {
            this.$emit( 'scroll-bottom', tipo );

        } );
    }

    public ElementScrollTo( element: HTMLElement, x: number, tipo: 'auto' | 'smooth' = 'auto' )
    {
        if ( element )
        {
            element.scrollTo( {
                left: 0,
                top: element.scrollHeight - x,
                behavior: tipo
            } );
        }
    }

    public ElementScroll( element: HTMLElement, x: any, tipo: 'auto' | 'smooth' = 'auto' )
    {
        if ( element )
        {
            x.behavior = tipo;
            x.left = 0;
            element.scrollTo( x );
        }
    }

    public ElementScrollBottom( element: HTMLElement, tipo: 'auto' | 'smooth' = 'auto' )
    {
        if ( element )
        {
            element.scrollTo( {
                left: 0,
                top: element.scrollHeight - element.clientHeight,
                behavior: tipo
            } );
        }
    }

    public ElementScrollTop( element: HTMLElement, tipo: 'auto' | 'smooth' = 'auto' )
    {
        if ( element )
        {
            element.scrollTo( {
                left: 0,
                top: 0,
                behavior: tipo
            } );
        }
    }

    public ScrollTop: number = 0;
    public OffsetY: number = 0;
    public PorcentajeY: number = 0;
    public get Top(): boolean
    {
        return this.ScrollTop == 0;
    }

    public get End(): boolean
    {
        return this.ScrollTop == this.OffsetY;
    }
}

export class Mensaje
{

    public async SiNo( Titulo: string = "", Mensaje: string = "¿Continuar?", Si: string = "Si", No: string = "Cancelar", MensajeAyuda: string = "" ): Promise<boolean>
    {
        throw new Error( 'Method not implemented.' );
    };

    public async Aceptar( Titulo: string = "", Mensaje: string = "¿Continuar?", Aceptar: string = "Aceptar", MensajeAyuda: string = "" ): Promise<boolean>
    {
        throw new Error( 'Method not implemented.' );
    };

    public async Imagenes( Titulo: string = "", Imagenes: string[] = []): Promise<boolean>
    {
        throw new Error( 'Method not implemented.' );

    };

    public async SiNoCancelar( Titulo: string = "", Mensaje: string = "¿Continuar?", Si: string = "Si", No: string = "No", MensajeAyuda: string = "" ): Promise<'s' | 'n' | 'c'>
    {
        throw new Error( 'Method not implemented.' );
    };


}

export class Notificacion implements e
{

    Error( Mensaje: string ): void
    {
        throw new Error( 'Method not implemented.' );
    } Completado( Mensaje: string ): void
    {
        throw new Error( 'Method not implemented.' );
    }
    Info( Mensaje: string ): void
    {
        throw new Error( 'Method not implemented.' );
    }
    Alerta( Mensaje: string ): void
    {
        throw new Error( 'Method not implemented.' );
    }



}

interface e
{
    Error( Mensaje: string ): void;
    Completado( Mensaje: string ): void;
    Info( Mensaje: string ): void;
    Alerta( Mensaje: string ): void;
}

export type keyEvent = {
    key: string;
    code: string;
    ctrlKey: boolean;
    shiftKey: boolean;
    altKey: boolean;
    metaKey: boolean;
    preventDefault: Function;
};

export const Utiles = new EventBus();

export function validarCuit( cuit: string )
{

    if ( cuit.length != 11 )
    {
        return false;
    }

    var acumulado = 0;
    var digitos: number[] = cuit.split( "" ).map( x => x.toInt() );
    var digito = digitos.pop();

    for ( var i = 0; i < digitos.length; i++ )
    {
        acumulado += digitos[9 - i] * ( 2 + ( i % 6 ) );
    }

    var verif = 11 - ( acumulado % 11 );
    if ( verif == 11 )
    {
        verif = 0;
    }

    return digito == verif;
}

export function utf8_to_b64( str: string )
{
    return window.btoa( unescape( encodeURIComponent( str ) ) );
}

export function b64_to_utf8( str: string )
{
    return decodeURIComponent( escape( window.atob( str ) ) );
}